var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9491 1.91577H4.37261C1.96149 1.91577 0 3.87726 0 6.28838V13.0419C0 14.9658 1.26314 16.6414 3.09352 17.1778L5.20533 19.2897C5.32261 19.4069 5.48138 19.4727 5.64714 19.4727C5.81274 19.4727 5.97167 19.4069 6.0888 19.2897L8.02605 17.3523H16.9491C19.3602 17.3523 21.3217 15.3908 21.3217 12.9797V6.28838C21.3217 3.87726 19.3602 1.91577 16.9491 1.91577ZM20.0724 12.9797C20.0724 14.7019 18.6713 16.103 16.9491 16.103H7.7674C7.6018 16.103 7.44287 16.1689 7.32575 16.286L5.64714 17.9646L3.85938 16.1769C3.77919 16.0967 3.67865 16.0397 3.56853 16.0124C2.20306 15.6726 1.24932 14.4511 1.24932 13.0419V6.28838C1.24932 4.56618 2.65041 3.16509 4.37261 3.16509H16.9491C18.6713 3.16509 20.0724 4.56618 20.0724 6.28838V12.9797Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.627 7.90521H6.69448C6.34946 7.90521 6.06982 8.18501 6.06982 8.52987C6.06982 8.8749 6.34946 9.15453 6.69448 9.15453H14.627C14.972 9.15453 15.2517 8.8749 15.2517 8.52987C15.2517 8.18501 14.972 7.90521 14.627 7.90521Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.627 10.1134H6.69448C6.34946 10.1134 6.06982 10.393 6.06982 10.7381C6.06982 11.0831 6.34946 11.3627 6.69448 11.3627H14.627C14.972 11.3627 15.2517 11.0831 15.2517 10.7381C15.2517 10.393 14.972 10.1134 14.627 10.1134Z",
    fill: "#1F1F1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3217,
    height: 21.3217,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.75072e66.svg";
export { ForwardRef as ReactComponent };